"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessagesAlert = ErrorMessagesAlert;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _HorizontalFlex = require("../containers/HorizontalFlex");

var _ButtonSecondary = require("../forms/ButtonSecondary");

var _ErrorAlert = require("./ErrorAlert");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function getUserFriendlyErrorMessage(error, errorMessagesByStatusCode) {
  if (!errorMessagesByStatusCode[error.statusCode]) {
    return "".concat(error.name, ": ").concat(error.message);
  }

  return errorMessagesByStatusCode[error.statusCode];
}

function renderClearButton(handleClear, clearErrorsLabel) {
  if (!handleClear) {
    return null;
  }

  return (
    /*#__PURE__*/
    _react["default"].createElement(_ButtonSecondary.ButtonSecondary, {
      onClick: function onClick() {
        return handleClear();
      }
    }, clearErrorsLabel)
  );
}

function ErrorMessagesAlert(props) {
  var clearErrorsLabel = props.clearErrorsLabel,
      errors = props.errors,
      errorMessagesByStatusCode = props.errorMessagesByStatusCode,
      handleClear = props.handleClear;

  if (errors.length === 0) {
    return null;
  }

  var uniqueErrors = errors.reduce(function (newErrors, currentError) {
    return newErrors.find(function (error) {
      return error.statusCode === currentError.statusCode;
    }) ? newErrors : [].concat(_toConsumableArray(newErrors), [currentError]);
  }, []).map(function (error) {
    return (
      /*#__PURE__*/
      _react["default"].createElement("li", {
        key: error.statusCode
      }, getUserFriendlyErrorMessage(error, errorMessagesByStatusCode))
    );
  });
  return (
    /*#__PURE__*/
    _react["default"].createElement(_ErrorAlert.ErrorAlert, null,
    /*#__PURE__*/
    _react["default"].createElement(_HorizontalFlex.HorizontalFlex, {
      cssClassModifiers: ['small-relative']
    },
    /*#__PURE__*/
    _react["default"].createElement("ul", null, uniqueErrors)), renderClearButton(handleClear, clearErrorsLabel))
  );
}

ErrorMessagesAlert.propTypes = {
  clearErrorsLabel: _propTypes["default"].string,
  errorMessagesByStatusCode: _propTypes["default"].objectOf(_propTypes["default"].string),
  errors: _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Object)),
  handleClear: _propTypes["default"].func
};
ErrorMessagesAlert.defaultProps = {
  clearErrorsLabel: 'Clear Errors',
  errorMessagesByStatusCode: {},
  errors: []
};